module.exports = __webpack_public_path__ + "media/components/shared/static/arrow_next-1e54beed0316c218e92f124b26124cdd.svg";